import type { JSX, ChangeEvent } from 'react';
import { useCallback } from 'react';
import { useColorPickerState } from './ColorPickerContext';
import { Switch } from '../Switch';

/**
 * Switch for contrast enforcement features.
 *
 * Provides a toggle switch to enable/disable minimum contrast enforcement
 * which automatically adjusts colors to meet accessibility standards.
 */
export const ContrastEnforcerSwitch = (): JSX.Element | null => {
  const { setShouldEnforceMinContrast, shouldEnforceMinContrast, hasAccessibleDerivatives } =
    useColorPickerState();

  const onChangeContrastLimitedSwitch = useCallback(
    (event: ChangeEvent) => {
      if (!(event.target instanceof HTMLInputElement)) {
        return;
      }
      const shouldLimit = event.target.checked;
      setShouldEnforceMinContrast(shouldLimit);
    },
    [setShouldEnforceMinContrast],
  );

  if (!hasAccessibleDerivatives) {
    return null;
  }

  return (
    <Switch
      align="right"
      checked={shouldEnforceMinContrast}
      label="Limit to high-contrast colors"
      onChange={onChangeContrastLimitedSwitch}
    />
  );
};
